import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { TextField, FormControlLabel, Checkbox } from '@material-ui/core';

const ToggleTextField = ({
  checkboxName,
  textFieldName,
  label,
  onCheckChange,
  onBlur,
  ...properties
}) => {
  const [isEnable, setIsEnable] = useState(false);
  const inputReference = useRef(null);
  const checkReference = useRef(null);

  const toggleInput = (event) => {
    setIsEnable(event.target.checked);
    onCheckChange(
      event.target.checked,
      textFieldName,
      inputReference.current.value
    );
  };

  const onBlurListener = () => {
    onBlur(
      checkReference.current.checked,
      textFieldName,
      inputReference.current.value
    );
  };

  return (
    <>
      <FormControlLabel
        sx={{ opacity: isEnable ? '1' : '0.5' }}
        control={
          <Checkbox
            name={checkboxName}
            inputRef={checkReference}
            value="true"
            color="primary"
            onChange={toggleInput}
          />
        }
        label={label}
      />
      <TextField
        name={textFieldName}
        id={textFieldName}
        inputRef={inputReference}
        onBlur={onBlurListener}
        label=""
        disabled={!isEnable}
        {...properties}
        sx={{
          opactity: isEnable ? '1' : '0.4',
          backgroundColor: isEnable ? '#fff' : '#eeeeee',
        }}
      />
    </>
  );
};

ToggleTextField.propTypes = {
  checkboxName: PropTypes.string,
  textFieldName: PropTypes.string,
  label: PropTypes.string,
  onCheckChange: PropTypes.func,
  onBlur: PropTypes.func,
};

ToggleTextField.defaultProps = {
  checkboxName: 'checkboxName',
  textFieldName: 'textFieldName',
  label: 'label',
  onCheckChange: null,
  onBlur: null,
};

export default ToggleTextField;
